// Staff can look at dilatih.co as a participant (peserta) with their own account: their
// classes, materials and certificates. The participant pages and APIs already work for any
// logged-in user; this only switches which sidebar/header they get. Per browser, cleared on
// login and logout.

const KEY = 'view_as_peserta'
// Peserta, reseller and trainer have their own portals and are not "staff".
const NOT_STAFF = [2, 3, 6]

export function isStaff(profile) {
  const role = Number(profile?.id_role)
  return !!role && !NOT_STAFF.includes(role)
}

export function viewingAsPeserta(profile) {
  try {
    return isStaff(profile) && window.localStorage.getItem(KEY) === '1'
  } catch (e) {
    return false
  }
}

// The role the admin layout should render for: 2 (peserta) while a staff member views as one.
export function effectiveRole(profile) {
  return viewingAsPeserta(profile) ? 2 : Number(profile?.id_role)
}

export function setViewAsPeserta(on) {
  try {
    if (on) window.localStorage.setItem(KEY, '1')
    else window.localStorage.removeItem(KEY)
  } catch (e) {
    /* storage blocked: the switch simply doesn't stick */
  }
}
